import isEmpty from 'lodash/isEmpty';

import { getLocalisedUrl } from '@aqx-core/common/format/url';

/**
 * Open a url with the addition of localising the url
 * Same as the props from window.open()
 * @param url
 * @param target
 * @param features
 * @returns
 */
export const openUrl = (url: string | null | undefined, target?: string, features?: string) => {
  const redirectUrl = getLocalisedUrl(url);
  if (!(redirectUrl && !isEmpty(redirectUrl))) {
    return;
  }

  window.open(redirectUrl, target, features);
};
